import { SvgIcon, SvgIconProps } from '@mui/material'

const RecoverColoredIcon = ({ fill = '#122937', ...props }: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="9.95831"
          cy="9.91774"
          r="7.40895"
          stroke={fill}
          stroke-width="2.37375"
        />
        <rect
          x="15.0057"
          y="8.48514"
          width="4.23122"
          height="2.86527"
          rx="0.169554"
          fill="#89949B"
        />
        <rect
          x="0.679443"
          y="8.48514"
          width="4.23122"
          height="2.86527"
          rx="0.169554"
          fill="#89949B"
        />
        <rect
          x="8.52472"
          y="4.8702"
          width="4.23122"
          height="2.86527"
          rx="0.169554"
          transform="rotate(-90 8.52472 4.8702)"
          fill="#89949B"
        />
        <rect
          x="8.52563"
          y="19.1966"
          width="4.23122"
          height="2.86527"
          rx="0.169554"
          transform="rotate(-90 8.52563 19.1966)"
          fill="#89949B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.43542 6.25684C9.43542 5.968 9.66957 5.73385 9.95841 5.73385C10.2472 5.73385 10.4814 5.968 10.4814 6.25684V6.77983C11.3479 6.77983 12.0504 7.48228 12.0504 8.34879C12.0504 8.63763 11.8162 8.87178 11.5274 8.87178C11.2385 8.87178 11.0044 8.63763 11.0044 8.34879C11.0044 8.05995 10.7702 7.8258 10.4814 7.8258H9.43542C9.14658 7.8258 8.91243 8.05995 8.91243 8.34879V8.64087C8.91243 8.86598 9.05648 9.06583 9.27004 9.13702L10.9775 9.70619C11.6182 9.91975 12.0504 10.5193 12.0504 11.1946V11.4867C12.0504 12.3532 11.3479 13.0557 10.4814 13.0557V13.5787C10.4814 13.8675 10.2472 14.1017 9.95841 14.1017C9.66957 14.1017 9.43542 13.8675 9.43542 13.5787V13.0557C8.5689 13.0557 7.86646 12.3532 7.86646 11.4867C7.86646 11.1979 8.1006 10.9637 8.38944 10.9637C8.67828 10.9637 8.91243 11.1979 8.91243 11.4867C8.91243 11.7756 9.14658 12.0097 9.43542 12.0097H10.4814C10.7702 12.0097 11.0044 11.7756 11.0044 11.4867V11.1946C11.0044 10.9695 10.8603 10.7697 10.6468 10.6985L8.93927 10.1293C8.29859 9.91576 7.86646 9.3162 7.86646 8.64087V8.34879C7.86646 7.48228 8.5689 6.77983 9.43542 6.77983V6.25684Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  )
}

export default RecoverColoredIcon
